import React, { Suspense } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import CitySkeleton from '../components/facilities/CitySkeleton';

// heavy table + queries (≈200 KB) now lazy-loaded
const FacilityManagement = React.lazy(
  () => import('../components/facilities/FacilityManagement')
);

const FacilityBooking: React.FC = () => (
  <DashboardLayout>
    {/* Show city skeletons instantly while the bundle loads */}
    <Suspense fallback={<CitySkeleton count={6} className="p-4" />}>
      <FacilityManagement />
    </Suspense>
  </DashboardLayout>
);

export default FacilityBooking;
